var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dt-details2"},[_c('div',{staticClass:"dt-details--header"},[_c('div',{staticClass:"title",attrs:{"title":_vm.group && _vm.group.group_id}},[_c('span',[_vm._v(_vm._s(_vm.group.group_name))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }